import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { AIAgentLayout } from '@/components/Layouts'
import { Metadata } from '@/components/Metadata'
import { NextPageWithLayout } from '@/pages/_app'

/**
 * AI Agent Page Component
 * Renders the main AI agent interface and redirects to chat
 */
const AIAgentPage: NextPageWithLayout = () => {
  // Initialize the Next.js router
  const router = useRouter()

  // Effect to handle redirect
  useEffect(() => {
    // Redirect to the chat page when component mounts
    router.replace('/ai-agent/chat')
  }, [router])

  return (
    <>
      <Metadata
        title="GAIA | AI Agent"
        description="A collaborative multi-modality AI platform, GAIA is an ambitious movement to give human and AI agents superpowers, uncensored & equitable."
        type="website"
      />
    </>
  )
}

// Apply the AI Agent layout to the page
AIAgentPage.getLayout = (page) => <AIAgentLayout>{page}</AIAgentLayout>

export default AIAgentPage

export async function getServerSideProps() {
  return {
    redirect: {
      destination: '/ai-agent/chat',
      permanent: true,
    },
  }
}